import { useTranslation } from 'providers/GILT.provider';

const Search = ({ currentText, onTextChange, clearBtn, clearSearch }) => {
  const { t } = useTranslation();

  return (
    <div className="stock-search">
      <input
        type="text"
        className="form-control"
        placeholder={t('stocks.managerLayout.headerFilters.searchProductPlaceholder')}
        id="SearchProductInput"
        value={currentText}
        onChange={(e) => {
          onTextChange(e.target.value);
        }}
        autoComplete="off"
      />
      {clearBtn && <span onClick={clearSearch} role="button" tabIndex={0} className="btn-clear-search" />}
    </div>
  );
};

export default Search;
